import React, { useState } from "react";
import "./styles.scss";

const BrowseFile = (props) => {
  const [fileName, setFileName] = useState("");
  const handleOnChange = (e) => {
    const fileInput = document.getElementById(e.target.id);
    const fileNameIs = fileInput.files[0].name;
    setFileName(fileNameIs);
    props.onChange(e);
  };
  return (
    <label htmlFor={props.id} className={"browse-file-input"}>
      <input type="file" id={props.id} accept="image/png, image/jpeg" onChange={(e) => handleOnChange(e)} />
      <div className={"placeholder"}>{fileName === "" ? props.placeholder : fileName}</div>
      <div className={"button-decor"}>{props.buttonTxt}</div>
    </label>
  );
};

export default BrowseFile;
